<script setup lang="ts">
import ArticleManagement from 'src/components/article-management/ArticleManagement.vue';
</script>

<template>
  <ArticleManagement />
</template>
